import { type MetricField, type OrganicStatsResponseDimensionEntry } from "../../gql-generated/types";

export const extractMetricFromList = (
    list: readonly OrganicStatsResponseDimensionEntry[],
    metricName: MetricField,
): OrganicStatsResponseDimensionEntry | undefined => list.find(({ field }) => field?.fieldName === metricName);
